import { animationDurationInMS, colors, FadeInAnimation, font, ReduceMotion, spacing, zindex } from '@chegg-ui/theme';
import styled from 'styled-components';
export var CSPOnboardingWrapper = styled.div.withConfig({
  componentId: "sxxh39-0"
})(["position:relative;min-width:6.25rem;margin-left:", ";@supports (min-width:max-content){min-width:max-content;};"], spacing.px8);
export var CSPOnboardingOverlay = styled.div.withConfig({
  componentId: "sxxh39-1"
})(["position:fixed;width:100vw;height:100vh;background:rgba(0,0,0,0.5);left:0;top:3.75rem;&:after{content:'';position:fixed;left:0;top:0;width:100vw;height:3.75rem;}"]);
export var ModalWrapper = styled.section.withConfig({
  componentId: "sxxh39-2"
})(["position:absolute;z-index:", ";right:", ";top:", ";display:", ";flex-direction:column;justify-content:center;align-items:center;box-shadow:0 0 3px 0 rgba(0,0,0,0.26);animation:", ";", ""], zindex.modal, function (props) {
  return "-".concat(props.offset, "px");
}, function (props) {
  return "".concat(props.topOffset, "px");
}, function (props) {
  return props.isShown ? 'flex' : 'none';
}, FadeInAnimation({
  duration: animationDurationInMS.slow
}), ReduceMotion);
var BORDER_WIDTH = 1.22; // TODO review non fanta color

export var ModalHeader = styled.h2.withConfig({
  componentId: "sxxh39-3"
})(["height:5.25rem;width:100%;margin:0;display:flex;justify-content:center;align-items:center;background-color:", ";font-family:", ";font-weight:", ";font-size:", ";color:", ";text-align:center;position:relative;&:after{content:'';display:block;position:absolute;width:0;height:0;border-left:", "rem solid transparent;border-right:", "rem solid transparent;border-bottom:", "rem solid #515bad;z-index:103;right:", ";transform:translate(-50%);top:-1.125rem;}"], colors.royal, font.family["default"], font.weight.bold, font.size.px20, colors.white, BORDER_WIDTH, BORDER_WIDTH, BORDER_WIDTH, function (props) {
  return "calc(".concat(props.offset, "px - ").concat(BORDER_WIDTH * 2, "rem)");
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/styles.js
// module id = 1634
// module chunks = 11